import { IEmployeeFilter, IListItem } from "~/pages/Staff/assets/StaffFilter";
import { filterByArr } from "~/pages/Staff/assets/StaffFilter/lib";

const normalizeFilterItems = (filterItems: unknown): string[] | IListItem[] => {
  if (filterItems == null || filterItems === "") {
    return [];
  }
  if (Array.isArray(filterItems)) {
    return filterItems as string[] | IListItem[];
  }
  if (typeof filterItems === "string") {
    try {
      const parsed = JSON.parse(filterItems);
      if (Array.isArray(parsed)) {
        return parsed;
      }
    } catch {
      return [];
    }
    return [];
  }
  if (typeof filterItems === "object") {
    const values = Object.values(filterItems as Record<string, unknown>);
    if (
      values.length > 0 &&
      values[0] !== null &&
      typeof values[0] === "object" &&
      "value" in (values[0] as object)
    ) {
      return values as IListItem[];
    }
  }
  return [];
};

const stringItemToListItem = (el: string): IListItem => {
  const i = el.indexOf(",");
  if (i === -1) {
    return { label: el.trim(), value: el.trim() };
  }
  return {
    value: el.slice(0, i).trim(),
    label: el.slice(i + 1).trim(),
  };
};

export const getFilterStaffFromLocation = (
  filterBy: string,
  filterItems: unknown,
  period: string
): IEmployeeFilter => {
  const items = normalizeFilterItems(filterItems);
  return {
    filterBy: filterByArr.find((el) => el.value === filterBy),
    filterItems: items.map((el) => {
      if (typeof el === "string") {
        return stringItemToListItem(el);
      }
      return el;
    }),
    period: new Date(decodeURI(period).split("T")[0]),
  };
};
